import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/core/useAuth";

export function ProtectedRoute({ children }) {
  const { user, staffProfile, isLoading } = useAuth();

  console.log("ProtectedRoute:", {
    user,
    staffProfile,
    isLoading,
    isAuthenticated: !!user && !!staffProfile,
  });

  // Always show loading state while checking auth
  if (isLoading) {
    console.log("Loading state:", {
      isLoading,
      hasUser: !!user,
      hasStaffProfile: !!staffProfile,
    });
    return (
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          fontSize: "1.2em",
        }}
      >
        Loading...
      </div>
    );
  }

  // Only redirect if fully loaded and no auth
  if (!user || !staffProfile) {
    console.log("Access denied:", {
      hasUser: !!user,
      hasStaffProfile: !!staffProfile,
      currentPath: window.location.pathname,
    });

    // Don't store path if already on auth page
    if (window.location.pathname !== "/auth") {
      // Store full URL including search params and hash
      const returnTo = window.location.pathname + window.location.search + window.location.hash;
      sessionStorage.setItem("returnTo", returnTo);
    }

    return <Navigate to="/auth" state={{ from: window.location.pathname }} />;
  }

  return children;
}
